import { render } from "./JSONataEditor.vue?vue&type=template&id=0bb68fa0"
import script from "./JSONataEditor.vue?vue&type=script&lang=js"
export * from "./JSONataEditor.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__